module.exports = __webpack_public_path__ + "static/media/25UNHCR3.f9ed85c0.jpg";